// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const STROLLERS_COMPARISON = "Porovnaj";
export const STROLLERS_COMPARISON_REMOVE_ALL = "Odober v\u0161etko";
export const STROLLERS_COMPARISON_TITLE = "Porovnanie ko\u010d\u00edkov";
export const STROLLER_SEO_GENERAL_DESC = "Ve\u013ek\u00e1 datab\u00e1za ko\u010d\u00edkov Modr\u00e9ho kon\u00edka";
